<template>
  <div class="bg">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-spacer></v-spacer>
              <v-card class="elevation-12">
                <v-toolbar-title>
                  <v-img
                    class="logo mt-2"
                    :src="require('@/assets/images/logo-ciceron-color@2x.png')"
                  ></v-img>
                </v-toolbar-title>
                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      prepend-icon="person"
                      v-model="username"
                      name="username"
                      :rules="[rules.vacio, rules.email ]"
                      :label="`${$t('username')} / ${$t('email')}`"
                      type="text"
                      required
                    ></v-text-field>
                    <v-text-field
                      @keyup.enter="submit"
                      prepend-icon="lock"
                      v-model="password"
                      name="password"
                      :rules="[v=>rules.vacio(v,'password'),rules.min]"
                      :label="$t('password')"
                      type="password"
                      required
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <router-link :to="{name:'lostPassword'}">{{$t('messages.forgotPassword')}}</router-link>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    color="primary"
                    :disabled="!valid"
                    :loading="loggingIn"
                    @click="submit"
                  >{{$t('login')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer class="pa-3 footer-bg">
        <span class="caption">Cicerón &copy; {{ new Date().getFullYear() }}</span>
        <v-spacer></v-spacer>
        <span class="caption mr-1">
          <a to>{{$t('termsAndConditions')}}</a> |
          <a to>{{$t('termsOfUse')}}</a>
        </span>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import rules from '../../helpers/rules'
export default {
  data: () => ({
    drawer: null,
    username: '',
    password: '',
    submitted: false,
    valid: true
  }),
  mixins: [rules],
  props: {
    source: String
  },
  computed: mapState({
    loggingIn: state => state.authentication.status.loggingIn
  }),
  created () {
    // reset login status
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    submit () {
      this.submitted = true
      const { username, password } = this
      const { dispatch } = this.$store
      if (this.$refs.form.validate()) {
        dispatch('authentication/login', { username, password })
      }
    }
  }
}
</script>

<style>
.logo {
  margin: auto;
  max-width: 250px;
}
.bg {
  background-image: url(/dark-material-bg.jpg);
  background-size: cover;
}
#inspire {
  background: none;
}
.footer-bg {
  color: white !important;
  background-color: transparent !important;
}
</style>
